import { createApp } from 'vue'

type VueComponentsDeterminator = { [key: string]: any } // any means vue component

const mountVue = (root: HTMLDivElement, componentList: VueComponentsDeterminator) => {
    type KeyOfComponents = string
    const vComponentKey = root.dataset.vueRoot as KeyOfComponents
    const vComponent = componentList[vComponentKey]
    const tagsToExclude = [
        'cross-edit-view',
        'page-edit-view',
        'wishlist-button',
        'store-locator'
    ]

    if ( !!!vComponent && !vComponentKey.includes(',') ) return

    const isComplex = [...root.children].length > 0
    const app = !isComplex ? createApp(vComponent) : createApp({
        components: {
            ...vComponentKey.split(',').reduce((a, key) => {
                const clearKey = key.trim() as KeyOfComponents
                return { ...a, [clearKey]: componentList[clearKey] }
            }, {})
        }
    })

    app.config.compilerOptions.isCustomElement = ( tag ) => tag.includes('-') && !tagsToExclude.includes(tag)
    app.config.globalProperties.window = window

    if ( process.env.NODE_ENV === 'development' ) {
        app.config.performance = true

        app.config.errorHandler = ( ...args ) => {
            // HERE WE CAN SEND CUSTOM SENTRY MESSAGES PER APP/SFC
            console.error('VUE ERROR!')
            console.log(args)
        }

        app.config.warnHandler = ( ...args ) => {
            // HERE WE CAN SEND CUSTOM SENTRY MESSAGES PER APP/SFC
            console.warn('VUE WARN!!')
            console.log(args)
        }
    }

    app.mount(root)
}

const getVueRoots = () => {
    return [...document.querySelectorAll<HTMLDivElement>('[data-vue-root]:not([data-v-app])')]
}

const filterByComponents = ( allowedComponents: VueComponentsDeterminator, vueRoots: HTMLDivElement[] ) => {
    if ( vueRoots.length === 0 ) return []
    const componentKeys = Object.keys(allowedComponents)
    const filtered = vueRoots.filter(x =>
        componentKeys.some(key => x.dataset.vueRoot?.includes(key))
    )

    return filtered
}

const loadVue = ( keyValComponents: VueComponentsDeterminator ) => {
    const vueRoots = filterByComponents(keyValComponents, getVueRoots())
    if ( vueRoots.length === 0 ) return

    vueRoots.forEach(root => mountVue(root, keyValComponents));
}

export {
    loadVue,
    VueComponentsDeterminator
}
